import type { BackendError } from '@/types/errors'

// Dettaglio del 409 "conferma richiesta" restituito dal backend quando i codici IFC (ins_codice) della
// mappatura marker 3D non combaciano coi sensori a DB o si sta azzerando una mappatura popolata.
type IfcConfirmDetail = {
    code: string
    emptyOverwrite: boolean
    orphanCodes: string[]
    existingMarkers: number
}

// Errore tipizzato lanciato dal layer di rete sul 409 IFC_CONFIRM_REQUIRED: il form lo intercetta per
// mostrare l'avviso e, su conferma dell'utente, rifà il salvataggio con confirmIfcOverwrite=true.
class IfcConfirmRequiredError extends Error {
    readonly detail: IfcConfirmDetail

    constructor(detail: IfcConfirmDetail, message: string) {
        super(message)
        this.name = 'IfcConfirmRequiredError'
        this.detail = detail
        // Preserva la catena di prototipi (necessario per instanceof dopo la transpilazione).
        Object.setPrototypeOf(this, IfcConfirmRequiredError.prototype)
    }
}

const parseBackendError = (error: unknown): string | undefined => {
    try {
        const e = error as Error
        const errorString = e.message

        const parts = errorString.split('|').map((part) => part.trim())

        const statusCode = parts[0]
        const statusMessage = parts[1]
        const errorObject = JSON.parse(parts[2]) as BackendError

        const result = [statusCode, statusMessage, errorObject.title].join(' | ')
        return result
    } catch (parseError: unknown) {
        return undefined
    }
}

const parseBackendErrorMessage = (errorString: string): string | undefined => {
    if (!errorString || errorString.length === 0) return undefined
    const errorObject = JSON.parse(errorString) as BackendError
    const { errors } = errorObject
    const result = Object.entries(errors)
        .map(([value, key]) => {
            return `${value}: ${key.join(', ')}`
        })
        .join(' | ')
    return result
}

export { IfcConfirmRequiredError, parseBackendError, parseBackendErrorMessage, type IfcConfirmDetail }
